import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { message } from "../../../actions";
import { createQuestions, patchQuestions } from "../actions/Questions";

import Icon from "../../../components/Icon";
import { patchQuestionnaires } from "../actions/Questionnaires";
import TextEditor from "../components/TextEditor";
import QuestionnaireEditor from "../components/QuestionnaireEditor";

const mapStateToProps = ( state ) =>
{
	return {
		questionnaires: state.questionnaires,
		questions: state.questions,
		blocksByQuestionnaireId: state.blocksByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		patchQuestionnaires: ( formData ) =>
		{
			dispatch( patchQuestionnaires( formData ) );
		},
		patchQuestions: ( a_formData, a_question_id, a_block_id, a_questionnaire_id, a_params ) =>
		{
			dispatch( patchQuestions( a_formData, a_question_id, a_block_id, a_questionnaire_id, a_params ) );
		},
		postQuestions: ( question ) =>
		{
			dispatch( createQuestions( question ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Questionkomponente der GUI
 */
class Question extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			error: null,
			binaryOption: null,
			question: null,
			questionNote: null,
			saveDisabled: true
		};
		
		this.handleEditQuestion = this.handleEditQuestion.bind( this );
		this.handleType = this.handleType.bind( this );
		
		// Editorrückgaben merken
		this.handleQuestionEdit = this.handleQuestionEdit.bind( this );
		this.handleQuestionNoteEdit = this.handleQuestionNoteEdit.bind( this );
		
	} // function constructor(...)
	
	componentDidUpdate( prevProps, prevState, snapshot )
	{
		const { node } = { ...this.props };
		
		if ( prevProps.node && node && prevProps.node.id !== node.id )
		{
			this.setState(
				{
					saveDisabled: true
				}
			);
		}
		
	} // function componentDidUpdate(...)
	
	/**
	 * Fragetyp ändern
	 *
	 * @param {boolean} a_binaryOption Fragetyp Binär (true) oder Liste (false)
	 */
	handleType( a_binaryOption )
	{
		this.setState( { binaryOption: a_binaryOption, saveDisabled: false } );
		
	} // function handleType(...)
	
	/**
	 * Fragetext ändern
	 *
	 * @param {string} a_html Fragetext
	 */
	handleQuestionEdit( a_html )
	{
		this.setState( { question: a_html, error: null, saveDisabled: false } );
		
	} // function handleQuestionEdit(...)
	
	/**
	 * Fragehinweistext ändern
	 *
	 * @param {string} a_html Fragehinweistext
	 */
	handleQuestionNoteEdit( a_html )
	{
		this.setState( { questionNote: a_html, saveDisabled: false } );
		
	} // function handleQuestionNoteEdit(...)
	
	/**
	 * Eine neue Frage speichern
	 */
	handleNewQuestion()
	{
		const { blocksByQuestionnaireId, questionnaires, lastSelectedNode, questionnaireId, questions } = { ...this.props };
		
		const question = {
			// Wenn der Fragetyp nicht gewählt wurde, dann ist er im Standard binär
			binary: this.state.binaryOption !== null ? this.state.binaryOption : true,
			question: this.state.question !== null ? this.state.question : "",
			note: this.state.questionNote !== null ? this.state.questionNote : ""
		};
		
		// Pflichtfelder prüfen
		if ( question.question.length === 0 )
		{
			this.setState( { error: "question" } );
			this.props.message( "Bitte den Fragetext eingeben.", "warning", 5000 );
			return;
		}
		
		let blockId = 0;
		switch ( lastSelectedNode.type )
		{
			case "blocks":
				blockId = lastSelectedNode.id;
				break;
			case "questions":
				blockId = lastSelectedNode.block_id;
				break;
			case "answers":
				// TODO Die blocksByQuestionnaireId sollte in den questions die Information der block_id haben
				blockId = questions[questionnaireId][lastSelectedNode.question_id].block_id;
				break;
			default:
				break;
		}
		
		// Pflichtfelder prüfen
		if ( blockId === 0 )
		{
			this.props.message( "Fehler bei der Ermittlung der Block Id.", "error" );
			return;
		}
		
		// Sortierung bestimmen
		const blockQuestions = blocksByQuestionnaireId[questionnaireId][blockId]["questions"];
		const lastQuestionId = Object.keys( blockQuestions )
			.sort( ( question1, question2 ) => blockQuestions[question1].sort_id - blockQuestions[question2].sort_id ).pop();
		const lastQuestion = blockQuestions[lastQuestionId];
		const formData = {
			...question,
			questionnaire_id: questionnaireId,
			block_id: blockId,
			sort_id: lastQuestion !== undefined ? Number.parseInt( lastQuestion.sort_id, 10 ) + 1 : 1
		};
		
		// ggf. Umsoritierung festlegen
		let newSortId = null;
		if ( lastSelectedNode.type === "questions" )
		{
			const selectedQuestion = blockQuestions[lastSelectedNode.id];
			newSortId = Number.parseInt( selectedQuestion.sort_id, 10 ) + 1;
		}
		else if ( lastSelectedNode.type === "answers" )
		{
			const selectedQuestion = blockQuestions[lastSelectedNode.question_id];
			newSortId = Number.parseInt( selectedQuestion.sort_id, 10 ) + 1;
		}
		
		if ( newSortId !== null && newSortId !== formData["sort_id"] )
		{
			formData["new_sort_id"] = newSortId;
		}
		
		this.props.postQuestions( formData );
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
		this.setState( { saveDisabled: false } );
		
	} // function handleNewQuestion()
	
	/**
	 * Einen Fragebogen ändern
	 *
	 * @param {Object} a_question Inhalte des geänderten Frage
	 */
	handleEditQuestion( a_question )
	{
		const { blocksByQuestionnaireId, questionnaires, questionnaireId, node } = { ...this.props };
		const block = node && node.block_id && questionnaireId && blocksByQuestionnaireId ? blocksByQuestionnaireId[questionnaireId][node.block_id] : null;
		const question = block ? block.questions[node.id] : null;
		
		const formData = {
			binary: this.state.binaryOption !== null ? this.state.binaryOption : a_question.binary,
			question: this.state.question !== null ? this.state.question : a_question.question,
			block_id: a_question.block_id,
			note: this.state.questionNote !== null ? this.state.questionNote : a_question.note
		};
		
		// Pflichtfelder prüfen
		if ( formData.question.length === 0 )
		{
			return this.props.message( "Bitte den Fragetext eingeben.", "warning", 5000 );
		}
		
		// Wenn keine Änderungen vorliegen, dann abbrechen
		let isChanged = QuestionnaireEditor.compareNodes( question, formData );
		if ( !isChanged )
		{
			this.props.message( "Es liegen keine Änderungen vor." );
			return this.setState( { saveDisabled: true } );
		}
		
		this.props.patchQuestions( formData, a_question.id, a_question.block_id, questionnaireId );
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
	} // function handleEditQuestion(...)
	
	render()
	{
		const { className = null, blocksByQuestionnaireId, questionnaireId, node } = { ...this.props };
		const block = node && node.block_id && questionnaireId && blocksByQuestionnaireId ? blocksByQuestionnaireId[questionnaireId][node.block_id] : null;
		const question = block ? block.questions[node.id] : null;
		const answersCount = question ? Object.keys( question.answers ).length : 0;
		const binary = this.state.binaryOption !== null ? this.state.binaryOption : question ? question.binary : true;
		
		return <div className={className}>
			{
				node &&
				<div className={"breadcrumb label"}>{node.breadcrumb}</div>
			}
			<h5>{node ? `Frage ${node.sortId}` : "Neue Frage"}</h5>
			{
				question
					? <React.Fragment>
						<label className={"label-note-editor"}>Fragetyp:<span className="form-element-required">*</span></label>
						<button className={"btn-flat btn-radio svg secondary-color-text"} onClick={() => this.handleType( true )} disabled={answersCount > 2}>
							<span className={`icon-rounded hover-primary-color hover-white-text icon-shadow${binary ? " white-text primary-color" : ""}`}>
								<Icon size={22} verticalAlign={"middle"} iconName={"binaryAnswer"}/>
							</span>
							<span>Ja|Nein</span>
						</button>
						<button className={"btn-flat btn-radio svg secondary-color-text"} onClick={() => this.handleType( false )}>
							<span className={`icon-rounded hover-primary-color hover-white-text icon-shadow${!binary ? " white-text primary-color" : ""}`}>
								<Icon size={22} verticalAlign={"middle"} iconName={"answerList"}/>
							</span>
							<span>Liste</span>
						</button>
						<label className={"label-note-editor"} htmlFor={`label_question_id_${question.id}`}>Fragetext:<span className="form-element-required">*</span></label>
						<TextEditor key={`question_editor_question_id_${question.id}`}
						            onSubmit={( html ) => this.handleQuestionEdit( html )}
						            className={this.state.error === "question" ? "validation-failed" : ""}
						            trigger={
							            <div className={"text-input editorIcon"} dangerouslySetInnerHTML={{ __html: question.question }}/>
						            }
						            additionalKey={`question_id_${question.id}`}
						            content={question.question}
						/>
						<label className={"label-note-editor"} htmlFor={`label_question_note_id_${question.id}`}>Hinweistext:</label>
						<TextEditor key={`note_editor_question_id_${question.id}`}
						            onSubmit={( html ) => this.handleQuestionNoteEdit( html )}
						            isHidden
						            trigger={
							            <div className='text-input editorIcon'>
								            <div dangerouslySetInnerHTML={{
									            __html: question.note
										            ? question.note
										            : ""
								            }}/>
							            </div>
						            }
						            content={question.note}
						/>
						<button className={"buttonTopSpace"} onClick={() => this.handleEditQuestion( question )} disabled={this.state.saveDisabled}>
							<Icon iconName={"edit"}/><span>Frage ändern</span>
						</button>
					</React.Fragment>
					: <React.Fragment>
						<label className={"label-note-editor"}>Fragetyp:<span className="form-element-required">*</span></label>
						<button className={"btn-flat btn-radio svg secondary-color-text"} onClick={() => this.handleType( true )} disabled={answersCount > 2}>
							<span className={`icon-rounded hover-primary-color hover-white-text icon-shadow${binary ? " white-text primary-color" : ""}`}>
								<Icon size={22} verticalAlign={"middle"} iconName={"binaryAnswer"}/>
							</span>
							<span>Ja|Nein</span>
						</button>
						<button className={"btn-flat btn-radio svg secondary-color-text"} onClick={() => this.handleType( false )}>
							<span className={`icon-rounded hover-primary-color hover-white-text icon-shadow${!binary ? " white-text primary-color" : ""}`}>
								<Icon size={22} verticalAlign={"middle"} iconName={"answerList"}/>
							</span>
							<span>Liste</span>
						</button>
						<label className={"label-note-editor"}>Fragetext:<span className="form-element-required">*</span></label>
						<TextEditor onSubmit={( html ) => this.handleQuestionEdit( html )} className={this.state.error === "question" ? "validation-failed" : ""}/>
						<label className={"label-note-editor"}>Hinweistext:</label>
						<TextEditor onSubmit={( html ) => this.handleQuestionNoteEdit( html )} isHidden/>
						<button className={"buttonTopSpace"} onClick={this.handleNewQuestion.bind( this )}>
							<Icon iconName={"edit"}/><span>Frage erstellen</span>
						</button>
					</React.Fragment>
			}
		</div>;
		
	} // function render()
	
} // class

Question.propTypes = {
	className: PropTypes.string,
	node: PropTypes.object,
	isNew: PropTypes.bool,
	questionnaireId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ),
	lastSelectedNode: PropTypes.object
};

Question = connect(
	mapStateToProps,
	mapDispatchToProps
)( Question );

export default Question;